export const EOIRCaseInfoState = _ => ({})
